import { InvalidFieldsContext } from 'components/common-form/contexts/InvalidFieldsContext';
import { useContext, useMemo } from 'react';
import { areLegacyInvalidFields } from 'state/selectors/meta/static/utils';

import type { InvalidCount } from './model';

export function useCountInvalidFields(blocks: readonly (readonly string[])[]): InvalidCount[] {
  const invalidFields = useContext(InvalidFieldsContext);

  return useMemo(() => {
    let invalidFieldsList: string[];
    let fieldsInErrorList: string[];

    if (areLegacyInvalidFields(invalidFields)) {
      const { errors, warnings } = invalidFields;
      invalidFieldsList = errors.concat(warnings);
      fieldsInErrorList = errors;
    } else {
      invalidFieldsList = Object.keys(invalidFields);
      fieldsInErrorList = invalidFieldsList.filter(field =>
        invalidFields[field].some(error => error.severity === 'Error'),
      );
    }

    return blocks.map((fieldIds): InvalidCount => {
      const all = fieldIds.filter(x => invalidFieldsList.includes(x));
      const validations = areLegacyInvalidFields(invalidFields) ? [] : all.flatMap(f => invalidFields[f]);
      const hasErrors = fieldIds.some(f => fieldsInErrorList.includes(f));
      return {
        totalCount: all.length,
        validations,
        severity: hasErrors ? 'error' : 'warning',
      };
    });
  }, [blocks, invalidFields]);
}
